import posthog from 'posthog-js';

import { resetSegmentIdentity } from './segment';

/**
 * Clears the Segment and PostHog identities stored in the browser (user id AND anonymous id)
 * so the next visitor on this browser starts a fresh anonymous chain instead of inheriting
 * the previous user's identity. Explicit sign-out only.
 *
 * Lives in its own module (no store import) so the auth slice can call it without creating
 * an import cycle with `./index.tsx`.
 */
export const resetAnalyticsIdentity = () => {
  resetSegmentIdentity();

  // eslint-disable-next-line no-underscore-dangle
  if (posthog.__loaded) {
    posthog.reset();
  }
};
